"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _reactRedux = require("react-redux");
var _CreateProductSalableForm = _interopRequireDefault(require("./CreateProductSalableForm"));
var _ProductSalableActions = require("../ProductSalableActions");
var _CreateProduct = require("react-platform-product/dist/Product/dialogs/CreateProduct");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = (0, _BaseInjectors.injectToBaseCreationDialog)(
// Wrap the component with the needed HOCs
_lodash.default.flowRight((0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    pagination: state.productSalableReducer.pagination,
    categories: state.categoryOfProductReducer ? state.categoryOfProductReducer.categories : null,
    specificities: state.specificityOfProductReducer ? state.specificityOfProductReducer.specificities : null
  };
})), {
  // Pass the form
  createForm: _CreateProductSalableForm.default,
  // Override componentDidMount to fetch categories and specificities
  componentDidMount: function componentDidMount() {
    this.props.dispatch({
      type: 'FETCH_CATEGORIES_OF_PRODUCT'
    });
    this.props.dispatch({
      type: 'FETCH_SPECIFICITIES_OF_PRODUCT'
    });
  },
  endpoint: 'salable-products',
  postUpdateAction: _ProductSalableActions.FETCH_PRODUCT_SALABLES,
  // Define the fields that are excluded in the handleSubmit
  excludedFields: ['images', 'specificities', 'options'],
  // Handle the excluded field inside the customHandleSubmit
  customHandleSubmit: _CreateProduct.handleProductSubmit
});
exports.default = _default;